import React, { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import "../css/AssistanteToobib.css";

const AssistanteToobib = ({ utilisateurSurTelephone }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showIntro, setShowIntro] = useState(true);
  const [messages, setMessages] = useState([{ text: "Quels soucis rencontrez-vous ?", type: "bot" }]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const toggleWindow = () => setIsOpen(!isOpen);
  const handleNext = () => setShowIntro(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { text: input, type: "user" };
    setMessages((prevMessages) => [...prevMessages, userMessage]);
    const userInput = input;
    setInput("");
    setLoading(true);

    try {
      const response = await fetch("https://carto.api.toobib.org/api/reponse_assistant", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userInput }),
      });

      
      const data = await response.json();
      console.log(data)
      if (response.ok && data.response) {
        setMessages((prevMessages) => [...prevMessages, { text: data.response, type: "bot" }]);
      } else {
        throw new Error(data.message || "Erreur lors de la récupération de la réponse");
      }
    } catch (error) {
      console.error("Erreur API :", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: "Désolé, une erreur s'est produite. Veuillez réessayer.", type: "bot" },
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ block: "end", behavior: "smooth" });
  }, [messages]);

  return (
    <div className="bubble-container">
      <div className={`window ${isOpen ? "show" : ""}`} onClick={(e) => e.stopPropagation()}>
        {showIntro ? (
          <div className="intro-container">
            <img src="embleme.png" alt="Chat Emblem" className="intro-logo" />
            <p className="intro-text">
              Bonjour ! Je suis Sophie, ton assistante personnelle Toobib. Je suis là pour t'aider à trouver des informations sur les établissements de santé et les professionnels de santé. 
              Pose-moi toutes tes questions, je ferai de mon mieux pour y répondre ! 
              
            </p>
            <button className="next-button" onClick={handleNext}>
              Suivant
            </button>
          </div>
        ) : (
          <>
            <div className="chat-header">
              <img src="embleme.png" alt="Chat Emblem" className="chat-logo" />
            </div>
            <div className="messages">
              {messages.map((msg, index) => (
                <div key={index} className={`message ${msg.type === "user" ? "user-message" : "bot-message"}`}>
                  {msg.type === "bot" ? 
                    <ReactMarkdown>{msg.text}</ReactMarkdown>
                    : 
                    <span>
                      {msg.text}
                    </span>}
                </div>
              ))}
              {loading && (
                <div className="bot-message">
                  <div className="spinner"></div>
                </div>
              )}
              <div ref={messagesEndRef} />
            </div>
            <div className="input-bar">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                placeholder="Écrivez votre message ici..."
                aria-label="Zone de saisie pour envoyer un message"
              />
              <button onClick={sendMessage} disabled={!input.trim()} aria-label="Envoyer le message">
                Envoyer
              </button>
            </div>
          </>
        )}
      </div>
      <button className="bubble" onClick={toggleWindow} aria-label="Ouvrir la conversation">
        <img src="conversation.png" alt="Ouvrir la conversation" />
      </button>
    </div>
  );
};

export default AssistanteToobib;
